<template>
  <div class="system-checker">
    <div class="container">
      <h1><span class="glyphicon glyphicon-cog"></span> {{ i18n.title }}</h1>
      <p class="introduction">{{ i18n.description }}</p>

      <div class="overall-status">
        <div class="row">
          <div class="col-sm-6">
            <div class="status">
              <strong class="in-progress" v-show="!completed">{{ i18n.checking }}</strong>
              <span v-show="!completed" ref="statusIndicator"></span>
              <strong v-show="completed">{{ i18n.complete }}</strong>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="pull-right" v-show="completed">
              <a class="btn btn-link btn-download" target="_blank" v-bind:href="downloadUrl">{{ i18n.downloadCSV }}</a>
            </div>
          </div>
        </div>
      </div>

      <connection-speed @initialized="registerChecker" @completed="completeChecker"></connection-speed>
      <popup-blocker @initialized="registerChecker" @completed="completeChecker"></popup-blocker>
      <cookie-enabled @initialized="registerChecker" @completed="completeChecker"></cookie-enabled>
      <screen-resolution @initialized="registerChecker" @completed="completeChecker"></screen-resolution>
      <browser-size @initialized="registerChecker" @completed="completeChecker"></browser-size>
      <web-browser @initialized="registerChecker" @completed="completeChecker"></web-browser>
      <operation-system @initialized="registerChecker" @completed="completeChecker"></operation-system>
      <cdn-access @initialized="registerChecker" @completed="completeChecker"></cdn-access>
      <real-time-server-access @initialized="registerChecker" @completed="completeChecker"></real-time-server-access>
      <api-connection-checker @initialized="registerChecker" @completed="completeChecker"></api-connection-checker>
      <video-player @initialized="registerChecker" @completed="completeChecker"></video-player>
    </div>
  </div>
</template>

<script>
import Spinner from 'spin.js'
import log from 'loglevel'
import ConnectionSpeed from './components/ConnectionSpeed'
import PopupBlocker from './components/PopupBlocker'
import CookieEnabled from './components/CookieEnabled'
import ScreenResolution from './components/ScreenResolution'
import BrowserSize from './components/BrowserSize'
import WebBrowser from './components/WebBrowser'
import OperationSystem from './components/OperationSystem'
import CdnAccess from './components/CdnAccess'
import RealTimeServerAccess from './components/RealTimeServerAccess'
import VideoPlayer from './components/VideoPlayer'
import ApiConnectionChecker from './components/ApiConnectionChecker'

log.setLevel('debug')

export default {
  name: 'system-checker',
  data () {
    return {
      completed: false,
      checkers: {},
      downloadUrl: '',
      i18n: window.SYSTEM_CHECK.i18n
    }
  },
  components: {
    ConnectionSpeed,
    PopupBlocker,
    CookieEnabled,
    ScreenResolution,
    BrowserSize,
    WebBrowser,
    OperationSystem,
    CdnAccess,
    RealTimeServerAccess,
    VideoPlayer,
    ApiConnectionChecker
  },
  mounted () {
    var spinner = new Spinner({
      color: '#333',
      width: 2,
      length: 0,
      radius: 5,
      top: '50%',
      left: '6.5%'
    }).spin()

    this.$refs.statusIndicator.appendChild(spinner.el)
  },
  methods: {
    registerChecker (checker) {
      log.debug('Checker[' + checker.name + '] registered')
      this.checkers[checker.name] = {completed: false}
    },
    completeChecker (checker) {
      log.debug('Checker[' + checker.name + '] completed')
      this.checkers[checker.name] = {completed: true, result: checker.result}

      var allCompleted = true

      // Check if all checkers have finished
      for (var name in this.checkers) {
        var status = this.checkers[name]
        if (!status.completed) {
          allCompleted = false
        }
      }
      this.completed = allCompleted
      if (this.completed) {
        this.setupDownloadButton()
      }
    },
    setupDownloadButton () {
      log.debug('Results are', this.checkers)
      var results = {checkers: []}
      for (var name in this.checkers) {
        var checker = this.checkers[name]
        results.checkers.push({
          name: name,
          result: checker.result
        })
      }

      this.downloadUrl = window.SYSTEM_CHECK.exportUrl + '?results=' + JSON.stringify(results)
    }
  }
}
</script>

<style>
  .system-checker {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333;
    margin: 0 auto 50px;
  }

  .system-checker .container {
    width: 730px;
  }

  .system-checker h1 {
    border-bottom: 1px solid #eee;
    font-size: 18px;
    line-height: 40px;
  }

  .system-checker h1 .glyphicon {
    top: 0;
    vertical-align: middle;
    margin-right: 5px;
  }

  .check-item {
    padding: 10px 0;
    border-bottom: 1px dashed #ccc;
  }

  .check-item .indicator {
    text-align: right;
  }

  .check-item .indicator span {
    vertical-align: middle;
  }

  .check-item .indicator.warning {
    color: #d58512;
  }

  .check-item .indicator.error {
    color: #a94442;
  }

  .check-item .indicator.passed {
    color: #4cae4c;
  }

  .check-item .alert {
    margin-top: 10px;
    margin-bottom: 0;
    padding: 6px 10px;
  }

  .system-checker .introduction {
    font-size: 14px;
  }

  .system-checker .overall-status {
	  margin: 25px 0 15px 0;
  }

  .system-checker .overall-status .status {
    line-height: 30px;
  }

  .system-checker .overall-status .status .in-progress {
    margin-left: 20px;
  }

  .system-checker .btn-download {
    padding: 0;
    line-height: 28px;
    text-decoration: underline;
  }

</style>
